namespace $.$$ {

	const Dragger_z = 11
	
	$mol_style_define( $shm_hitalama_map_page_dragger, {
		
		position: 'absolute',
		background: {
			color: $mol_theme.card,
		},
		minWidth: '35px',

		transition: 'none',
		// transformOrigin: '0 0',

		// translate: '-100% 0',
		// transformOrigin: '100% 0',

		// translate: '-100% -100%',
		// transformOrigin: '100% 100%',

		// opacity: 0,
		':hover': {
			opacity: 1,
			zIndex: Dragger_z,
		},
		zIndex: Dragger_z,

		userSelect: 'none',
		touchAction: 'none',

		cursor: 'grab',

		Icon_1: {
			width: '1.5rem',
			margin: '-0.65rem',
		},
		Icon_2: {
			width: '1.5rem',
			margin: '-0.65rem',
		},
		
	} )
	
}
